import { ApplicationState } from '@/store';
import { DependencyList, useEffect } from 'react';
import { useSelector } from 'react-redux';

type Props = {
    onChange?: () => void;
    unmountChange?: () => void;
};

export const useContentLanguageChange = ({ onChange, unmountChange }: Props, dependencies: DependencyList = []) => {
    const { availableContentLanguages } = useSelector((state: ApplicationState) => state.locale);

    useEffect(() => {
        onChange && onChange();

        return () => {
            unmountChange && unmountChange();
        };
    }, [availableContentLanguages, ...dependencies]);
};
